import { langToLocale, LOCALE_COOKIE_KEY } from '@/features/i18n/constants';

export const getInitialLocale = (): string => {
  const cookieMatch = document.cookie.match(new RegExp(`${LOCALE_COOKIE_KEY}=([^;]+)`));
  const lang = cookieMatch?.[1];
  if (lang) return langToLocale[lang] || lang;

  return 'en-US';
};

const toLanguage = (locale: string) => (locale.startsWith('nb') ? 'nb' : 'en');

let language: 'en' | 'nb' | undefined;

export const t = <T>(text: { en: T; nb: T }) => {
  language ??= toLanguage(getInitialLocale());
  return text?.[language];
};

export const setLanguage = (locale: string) => {
  language = toLanguage(locale);
};

export const saveLocale = (locale: string) => {
  setLanguage(locale);
  const shortCode = locale.split('-')[0];
  document.cookie = `${LOCALE_COOKIE_KEY}=${shortCode}; path=/; max-age=31536000; SameSite=Lax`;
};
